import { computed, Ref } from 'vue';
import * as yup from 'yup';
import { Borrower, ServiceType } from '@/models/loans';

export interface ValidationData {
	borrowers: Borrower[];
	documentTypeOptions: Ref<ServiceType[]>;
}

export function useFormFields(data: ValidationData) {
	const borrowerOptions: ServiceType[] = data.borrowers.map((borrower) => ({
		id: borrower.documentPersonId,
		name: borrower.fullName
	}));

	const formFields = computed(() => {
		return [
			{
				name: 'documentTypeId',
				label: 'Document Type',
				type: 'select',
				value: 23, // default, upload
				width: 'col-6',
				options: data.documentTypeOptions.value
			},
			{
				name: 'borrowerId',
				label: 'Borrower',
				type: 'select',
				value: null,
				width: 'col-6',
				options: borrowerOptions
			},
			{
				name: 'borrowerVisible',
				label: 'Borrower Visible',
				type: 'checkbox',
				value: false,
				width: 'col-12'
			}
		];
	});

	const validationSchema = computed(() => {
		return yup.object({
			documentTypeId: yup
				.number()
				.typeError('Document Type is invalid')
				.required('Document Type is required')
				.min(1),
			borrowerId: yup
				.number()
				.typeError('Borrower is invalid')
				.required('Borrower is required'),
			borrowerVisible: yup
				.boolean()
				.default(false)
		});
	});

	return {
		formFields,
		validationSchema
	};
}
